import script from "./OrderStatistics.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderStatistics.vue?vue&type=script&setup=true&lang=js"

import "./OrderStatistics.vue?vue&type=style&index=0&id=3b823748&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b823748"]])

export default __exports__